import Globals from "@/globals.js";
import Category from "@/objects/MotifCategory.js";
import MotifData from "@/objects/MotifData.js";
import apiClient from "@/services/ApiClient.js";

export default {
  getMotifs() {
    return apiClient.get("/motifs?includeCategories=true");
  },
  convertJsonToMotifList(jsonData) {
    let motifCats = [];

    for (let c of jsonData) {
      motifCats.push(new Category(c, Globals.motifImageFolderUrl));
    }
    return motifCats;
  },
  getMotifListFromJson(jsonData) {
    let motifs = [];
    for (let m of jsonData.motifs) {
      let md = new MotifData(m, Globals.motifImageFolderUrl);
        md.motifUrl = Globals.motifImageFolderUrl + md.motifUrl;        
      motifs.push(md);
    }
    return motifs;
  },
  getMotifCatListFromJson(jsonData) {
    let motifCats = [];
    for (let m of jsonData.motifCategories) {
      motifCats.push(new Category(m));
    }
    return motifCats;
  },
};
